
import './Roadmap.css';

function Roadmap() {
  return (
    <div className="body-set">
      <div className="body-section swatch-1">
        <h1>The Khaos Ecosystem Roadmap</h1>
        <h2>The Portfolio Companies</h2>
        <div className="company swatch-2">
          <h2>Khaos</h2>
          <h3>Upcoming Landmarks</h3>
            <ul>
              <li></li>
            </ul>
        <h3>Past Pitstops</h3>
          <ul>
            <li></li>
          </ul>
          <h3>Unfortunate Detours</h3>
          <ul>
            <li></li>
          </ul>
        </div>
        <div className="company swatch-3">
          <h2>Khaos Labs</h2>
          <h3>Upcoming</h3>
            <ul>
              <li>Raising money for a slate of 4 Feature Films to start production in 2022</li>
            </ul>
          <h3>Past Pitstops</h3>
          <ul>
            <li>Finished our First Feature Film – <a href="https://khaoslabs.com/productions/american-dreamers">American Dreamers (2020</a>)</li>
            <li>Produced the Short Films <a href="https://khaoslabs.com/productions/jessica">Jessica</a> and <a href="https://khaoslabs.com/productions/spark">Spark</a> (2020)</li>
            <li>Produced the Short Film <a href="https://khaoslabs.com/productions/SwimAlone">Swim Alone (2019)</a></li>
          </ul>
          <h3>Unfortunate Detours</h3>
          <ul>
            <li></li>
          </ul>
        </div>
        <div className="company swatch-5">
          <h2>Ramen Creative</h2>
          <h3>Upcoming Landmarks</h3>
            <ul>
              <li>Change Ramen Creative Website codebase to React from only HTML + CSS</li>
              <li>Full Revamp of Whisky Lane Website</li>
              <li></li>
            </ul>
          <h3>Past Pitstops</h3>
          <ul>
            <li></li>
          </ul>
          <h3>Unfortunate Detours</h3>
          <ul>
            <li></li>
          </ul>
        </div>
        <div className="company swatch-4">
          <h2>Crackling Coffee</h2>
          <h3>Upcoming Landmarks</h3>
            <ul>
              <li>Incoming Coffee Roaster</li>
            </ul>
        <h3>Past Pitstops</h3>
          <ul>
            <li></li>
          </ul>
          <h3>Unfortunate Detours</h3>
          <ul>
            <li></li>
          </ul>
        </div>
        <div className="company swatch-8">
          <h2>Film Retreats</h2>
          <h3>Upcoming Landmarks</h3>
            <ul>
              <li></li>
            </ul>
        <h3>Past Pitstops</h3>
          <ul>
            <li>Purcahsed <a href="https://filmretreats.com">FilmRetreats.com</a></li>
          </ul>
          <h3>Unfortunate Detours</h3>
          <ul>
            <li></li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Roadmap;
